import setFieldValue from "@iewcasia/Store/Handlers/CreateAccount/SetFieldValue";
import { CustomActions, CustomState } from "@iewcasia/Store/Reducers";
import { OwnProps, setRequestFormEffects, validateFieldBy } from "@iewcasia/Widgets/CreateAccount/FormBaseComponent";
import { getCountriesDataView } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import { loadCurrentCountriesParameter } from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import translate from "@insite/client-framework/Translate";
import Select from "@insite/mobius/Select";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => {
    const countriesDataView = getCountriesDataView(state, loadCurrentCountriesParameter);

    return {
        billingState: state.customCreateAccountForm.fieldValues.billingState,
        previouslyPurchased: state.customCreateAccountForm.fieldValues.previouslyPurchased,
        billingCountry: state.customCreateAccountForm.fieldValues.billingCountry,
        countries: countriesDataView.value,
    };
};

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const BillingStateWidget: React.FC<Props> = ({
    countries,
    previouslyPurchased,
    billingCountry,
    billingState,
    setFieldValue: widgetSetFieldValue,
}) => {
    const label = translate("State");
    const isRequired = true;
    const hintText = "Select";
    const [billingStateOptions, setbillingStateOptions] = React.useState<{ label: any; value: any }[]>([]);
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    setRequestFormEffects(isRequired, billingState, "billingState", () =>
        validateFieldBy(isRequired, label, billingState, setFieldErrorMessage),
    );

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        widgetSetFieldValue({ key: "billingState", value: event.target.value });
    };

    React.useEffect(() => {
        if (billingCountry) {
            widgetSetFieldValue({ key: "billingState", value: "" });
            const states = countries?.find?.((x: any) => x.name === billingCountry)?.states;
            setbillingStateOptions(states?.map?.((x: any) => ({ label: x.name, value: x.name })) || []);
        }
    }, [billingCountry]);

    return (
        <Select
            label={label}
            required={isRequired}
            value={billingState || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
            placeholder={hintText || ""}
        >
            <option value="" {...(isRequired && { disabled: true })}>
                {translate(hintText)}
            </option>
            {billingStateOptions.map((billingState: any) => (
                <option key={billingState.value} value={billingState.name}>
                    {billingState.label}
                </option>
            ))}
        </Select>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingStateWidget);
